<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-between">
            <!-- Start:: Ar title -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isArabic"
                  v-model.trim="data.title_ar"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.title_ar") }}
                </label>
              </div>
            </div>
            <!-- End:: Ar title -->

            <!-- Start:: En title -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isEnglish"
                  v-model.trim="data.title_en"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.title_en") }}
                </label>
              </div>
            </div>
            <!-- End:: En title -->

            <!-- Start:: Ar desc -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  {{ $t("forms.labels.desc_ar") }}
                </label>
                <textarea
                  @keypress="isArabic"
                  v-model="data.description_ar"
                  class="form-control"
                  rows="5"
                ></textarea>
              </div>
            </div>
            <!-- End:: Ar desc -->

            <!-- Start:: En desc -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  {{ $t("forms.labels.desc_en") }}
                </label>
                <textarea
                  @keypress="isEnglish"
                  v-model="data.description_en"
                  class="form-control"
                  rows="5"
                ></textarea>
              </div>
            </div>
            <!-- End:: En desc -->
          </div>
          <div class="row justify-content-between">
            <!-- Start:: Ar title -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isArabic"
                  v-model.trim="data.title_ar_ksa"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.title_ar") + $t("ksa") }}
                </label>
              </div>
            </div>
            <!-- End:: Ar title -->

            <!-- Start:: En title -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isEnglish"
                  v-model.trim="data.title_en_ksa"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.title_en") + $t("ksa") }}
                </label>
              </div>
            </div>
            <!-- End:: En title -->

            <!-- Start:: Ar desc -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  {{ $t("forms.labels.desc_ar") + $t("ksa") }}
                </label>
                <textarea
                  @keypress="isArabic"
                  v-model="data.description_ar_ksa"
                  class="form-control"
                  rows="5"
                ></textarea>
              </div>
            </div>
            <!-- End:: Ar desc -->

            <!-- Start:: En desc -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  {{ $t("forms.labels.desc_en") + $t("ksa") }}
                </label>
                <textarea
                  @keypress="isEnglish"
                  v-model="data.description_en_ksa"
                  class="form-control"
                  rows="5"
                ></textarea>
              </div>
            </div>
            <!-- End:: En desc -->
          </div>
        </div>
        <div class="repeater_wrapper mt-6 row">
          <v-expansion-panels>
            <v-expansion-panel
              v-for="(feature, index) in data.features.slice(0, 3)"
              :key="index"
              class="col-lg-12"
            >
              <v-expansion-panel-header>
                <h5>الميزة - {{ index + 1 }}</h5>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="row">
                  <!-- ********** Row Data ********** -->
                  <div class="upload_input_wrapper me-auto col-7">
                    <template v-if="feature.icon">
                      <uplode-image
                        :data_src="feature.icon"
                        @inputChanged="uplodeFeaturesImg($event, index)"
                        placeHolder="أرفق icon"
                      ></uplode-image>
                    </template>
                    <template v-else>
                      <uplode-image
                        @inputChanged="uplodeFeaturesImg($event, index)"
                        placeHolder="أرفق icon"
                      ></uplode-image>
                    </template>
                  </div>

                  <div class="col-lg-6 py-0">
                    <div class="input_wrapper top_label">
                      <input
                        type="text"
                        class="form-control"
                        @input="helper_checkIfInputIsEmpty"
                        @keypress="isArabic"
                        v-model.trim="feature.title_ar"
                      />
                      <label for="name_input" class="form-label"
                        >العنوان (عربي)</label
                      >
                    </div>
                  </div>
                  <div class="col-lg-6 py-0">
                    <div class="input_wrapper top_label">
                      <input
                        type="text"
                        class="form-control"
                        @input="helper_checkIfInputIsEmpty"
                        @keypress="isEnglish"
                        v-model.trim="feature.title_en"
                      />
                      <label for="name_input" class="form-label"
                        >العنوان (إنجليزي)</label
                      >
                    </div>
                  </div>
                  <div class="col-lg-6 py-0">
                    <div class="input_wrapper top_label">
                      <label for="textarea_1" class="form-label">
                        محتوي الميزة (عربي)</label
                      >
                      <textarea
                        class="form-control"
                        rows="5"
                        @keypress="isArabic"
                        v-model="feature.description_ar"
                      ></textarea>
                    </div>
                  </div>
                  <div class="col-lg-6 py-0">
                    <div class="input_wrapper top_label">
                      <label for="textarea_1" class="form-label"
                        >محتوي الميزة (إنجليزي)</label
                      >
                      <textarea
                        class="form-control"
                        rows="5"
                        @keypress="isEnglish"
                        v-model="feature.description_en"
                      ></textarea>
                    </div>
                  </div>
                  <div class="col-lg-4 py-0 mx-auto">
                    <div class="input_wrapper top_label">
                      <input
                        type="color"
                        class="form-control"
                        v-model.trim="feature.background"
                      />
                      <label for="name_input" class="form-label">
                        لون خلفية الميزة</label
                      >
                    </div>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div class="buttons_wrapper">
          <button class="base-btn" :class="btnIsLoading ? 'disabled' : ''">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",

  data() {
    return {
      dateMenu: false,
      dateMenu2: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.intro.title"),
          disabled: false,
          href: "/home_page/intro",
        },
        {
          text: this.$t("breadcrumb.intro.add&edit"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== create_data
      data: {
        title_ar: null,
        title_en: null,
        description_ar: null,
        description_en: null,
        title_ar_ksa: null,
        title_en_ksa: null,
        description_ar_ksa: null,
        description_en_ksa: null,
        features: [
          {
            background: null,
            icon: null,
            title_ar: null,
            title_en: null,
            description_ar: null,
            description_en: null,
          },
          {
            background: null,
            icon: null,
            title_ar: null,
            title_en: null,
            description_ar: null,
            description_en: null,
          },
          {
            background: "",
            icon: null,
            title_ar: null,
            title_en: null,
            description_ar: null,
            description_en: null,
          },
        ],
      },
    };
  },

  methods: {
    // Uplode Image
    uplodeFeaturesImg(obj, index) {
      this.data.features[index].icon = obj;
    },

    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;
      if (!this.data.title_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أدخل العنوان (عربي)",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
      } else if (!this.data.title_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أدخل العنوان (انجليزي)",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.description_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أدخل الوصف (عربي)",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.description_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أدخل الوصف (انجليزي)",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.title_ar_ksa) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أدخل العنوان (عربي) السعودية",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
      } else if (!this.data.title_en_ksa) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أدخل العنوان (انجليزي) السعودية ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.description_ar_ksa) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أدخل الوصف (عربي) السعودية",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.description_en_ksa) {
        this.$iziToast.error({
          timeout: 2000,
          message: " أدخل الوصف (انجليزي) السعودية",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.data.features.forEach((feature, index) => {
          if (!feature.title_ar) {
            this.$iziToast.error({
              timeout: 2000,
              message: `أدخل عنوان الميزة رقم ${index + 1}  (عربي)`,
              position: "bottomRight",
            });
            this.btnIsLoading = false;
            return;
          } else if (!feature.title_en) {
            this.$iziToast.error({
              timeout: 2000,
              message: `أدخل عنوان الميزة رقم ${index + 1}  (انجليزي)`,
              position: "bottomRight",
            });
            this.btnIsLoading = false;
            return;
          } else if (!feature.description_ar) {
            this.$iziToast.error({
              timeout: 2000,
              message: `أدخل محتوي الميزة رقم ${index + 1}  (عربي)`,
              position: "bottomRight",
            });
            this.btnIsLoading = false;
            return;
          } else if (!feature.description_en) {
            this.$iziToast.error({
              timeout: 2000,
              message: `أدخل محتوي الميزة رقم ${index + 1}  (انجليزي)`,
              position: "bottomRight",
            });
            this.btnIsLoading = false;
            return;
          } else if (!feature.icon) {
            this.$iziToast.error({
              timeout: 2000,
              message: `أدخل Icon الميزة رقم ${index + 1}  `,
              position: "bottomRight",
            });
            this.btnIsLoading = false;
            return;
          } else {
            this.submitData();
            return;
          }
        });
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      submit_data.append("ar[title]", this.data.title_ar);
      submit_data.append("en[title]", this.data.title_en);

      submit_data.append("ar[description]", this.data.description_ar);
      submit_data.append("en[description]", this.data.description_en);
      submit_data.append("ar[title_ksa]", this.data.title_ar_ksa);
      submit_data.append("en[title_ksa]", this.data.title_en_ksa);

      submit_data.append("ar[description_ksa]", this.data.description_ar_ksa);
      submit_data.append("en[description_ksa]", this.data.description_en_ksa);

      this.data.features.forEach((feature, index) => {
        submit_data.append(`features[${index}][ar][title]`, feature.title_ar);
        submit_data.append(`features[${index}][en][title]`, feature.title_en);
        submit_data.append(
          `features[${index}][ar][description]`,
          feature.description_ar
        );
        submit_data.append(
          `features[${index}][en][description]`,
          feature.description_en
        );
        if (feature.background) {
          submit_data.append(
            `features[${index}][background]`,
            feature.background
          );
        }
        if (feature.id) {
          submit_data.append(`features[${index}][id]`, feature.id);
        }
        if (feature.icon.img_file) {
          submit_data.append(`features[${index}][icon]`, feature.icon.img_file);
        }
      });

      this.axios({
        method: "POST",
        url: "home/intro",
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("addSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/home_page/intro" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
    // Set Rows
    setRows() {
      this.lodaing = true;
      this.axios({
        method: "GET",
        url: "home/intro",
      })
        .then((res) => {
          this.data = res.data.data;
          this.lodaing = false;

          console.log(res.data.data.features);
        })
        .catch(() => {
          this.lodaing = false;
        });
    },
  },

  // ======= hooks
  mounted() {
    // Set Rows
    this.setRows();
  },
};
</script>
